import { render, staticRenderFns } from "./LocalConfigWarning.vue?vue&type=template&id=f45b28b4&scoped=true"
import script from "./LocalConfigWarning.vue?vue&type=script&lang=js"
export * from "./LocalConfigWarning.vue?vue&type=script&lang=js"
import style0 from "./LocalConfigWarning.vue?vue&type=style&index=0&id=f45b28b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45b28b4",
  null
  
)

export default component.exports